/**
 * Redux slice for meetings page state.
 * Stores todayQueryArgs so the meeting detail can reuse the same RTK Query args
 * as useSearchData and get a cache hit (no duplicate request, no list remount).
 */
import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'meetingsPage',
  initialState: { todayQueryArgs: null },
  reducers: {
    setTodayQueryArgs: (state, action) => {
      state.todayQueryArgs = action.payload
    },
  },
})

export const { setTodayQueryArgs } = slice.actions
export const todayQueryArgsSelector = (state) => state.meetingsPage?.todayQueryArgs ?? null
export const reducer = slice.reducer
